import { render, staticRenderFns } from "./MoveFromExcludedConfirmationPopup.vue?vue&type=template&id=21ec8e8a&scoped=true&"
import script from "./MoveFromExcludedConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./MoveFromExcludedConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./MoveFromExcludedConfirmationPopup.vue?vue&type=style&index=0&id=21ec8e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec8e8a",
  null
  
)

export default component.exports